import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateDisplayNoShowModal } from "../../../reducer/bookingReducer";
import { CircularProgress } from "@mui/material";
import useAllBookingFunction from "../../../hooks/bookingCustomHook/useAllBookingFunction";

const ConfirmationModalNoShow = () => {
  const { displayNoShowModal } = useSelector((store) => store.booking);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { handleBookingToBeMarkedNoShow } = useAllBookingFunction(setLoading);
  const handleClose = () => {
    dispatch(updateDisplayNoShowModal());
  };

  return (
    <Modal
      open={displayNoShowModal}
      centered
      title=""
      mask={true}
      styles={{ mask: { backdropFilter: "blur(2px)" } }}
      width={"auto"}
      onCancel={handleClose}
      footer={
        <div className="w-[100%] flex gap-2 justify-center mt-5 font-outfit">
          <Button
            className="text-[16px] w-[11rem] h-[3rem]
            border-[#007FFF] text-[#007FFF] rounded-[0.5rem] font-[500] "
            onClick={handleClose}
          >
            NO
          </Button>

          <Button
            className="text-[#FFF] text-[16px] rounded-xl  bg-[#FC573B] 
            w-[11rem] h-[3rem] font-[600]"
            onClick={loading ? undefined : handleBookingToBeMarkedNoShow}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <div>YES</div>
            )}
          </Button>
        </div>
      }
    >
      <div className="font-nunito text-[1.125rem] font-[600] mb-2 text-[#4D4D4D]">
        Booking No Show?
      </div>
      <div className="text-[#808080] font-nunito text-[0.875remrem] font-[400]">
        By Clicking Yes your booking will be listed as No-show.
      </div>
    </Modal>
  );
};

export default ConfirmationModalNoShow;
